<template>
  <b-card
   
    class="card-congratulation-medal"
  >
    <h5>Congratulations 🎉 {{ $store.state.user.user.fullName }}!</h5>
    <b-card-text class="font-small-3">
      You have won gold medal
    </b-card-text>
    <h1 class="mb-75 mt-2 pt-50">
     {{total.openPosition}}
    </h1>
    <h4>
    Open Position.</h4>
    <b-img
      :src="require('@/assets/images/illustration/badge.svg')"
      class="congratulation-medal"
      alt="Medal Pic"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { kFormatter } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
       total: {
      type: Object,
      
    },
  },
  methods: {
    kFormatter,
  },
}
</script>
